import { useEffect, useState } from 'react'
import { Button, Container, SearchInput, Text } from '../../../'
import ConfirmDialog, { SuccessMessage } from '../../../shared/ConfirmDialog';
import { MdEdit, MdDelete, MdVisibility } from 'react-icons/md'
import StyledWorkbookFilterList from '../workbook-filter-list-styled'
import { apiUtils, store } from 'state';
import axios from 'axios';
import { getUserFromSubcookies } from 'utils/tools';



interface Territory {
  id: string
  name: string
  createdBy: string;
}

interface Props {
  onEdit: (territory: Territory | null) => void
}

export const WorkbookTerritoryList: React.FC<Props> = ({ onEdit }) => {
  const [territories, setTerritories] = useState<Territory[]>([])
  const [searchValue, setSearchValue] = useState('')
  const [territoryToDelete, setTerritoryToDelete] = useState<Territory | null>(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const currentUserId = getUserFromSubcookies()?.profile?.sub || '';



  const filtered = territories.filter(t =>
    t.name.toLowerCase().includes(searchValue.toLowerCase())
  )

  const confirmDeleteTerritory = async () => {
    if (!territoryToDelete) return;

    try {
      await apiUtils.checkToken();
      const { token } = store.getState().auth;

      const apiUrl = `${process.env.REACT_APP_API_URL_V2}/v2/Territory/${territoryToDelete.id}`;
      console.log('Deleting...', apiUrl);

      await axios.delete(apiUrl, {
        headers: {
          ...apiUtils.getHeaders(),
          Authorization: `${token?.token_type} ${token?.access_token}`,
        },
      });
      setTerritories(prev => prev.filter(t => t.id !== territoryToDelete.id));
      setSuccessMessage("Territory deleted successfully!");
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      alert("Failed to delete the territory.");
    } finally {
      setIsConfirmModalOpen(false);
      setTerritoryToDelete(null);
    }
  };


  useEffect(() => {
    const fetchTerritories = async () => {
      try {
        await apiUtils.checkToken();

        const { data } = await apiUtils.apiV2.get('/v2/Territory');
        if (Array.isArray(data)) {
          const parsed: Territory[] = data.map(t => ({
            id: t.territoryGuid,
            name: t.territoryName,
            createdBy: t.userGuid,
          }));
          setTerritories(parsed);
        }
      } catch (err) {
        console.error('Error fetching territories:', err);
      }
    };

    fetchTerritories();
  }, []);





  return (
    <StyledWorkbookFilterList className="workbook-territory-list">
      <SearchInput
        value={searchValue}
        placeholder="Search Territories"
        onClear={() => setSearchValue('')}
        onChange={(e) => setSearchValue(e.target.value)}
      />
      <Container className="list">
        {filtered.length > 0 ? (
          filtered.map((territory) => (
            <Container key={territory.id} className="filter">
              <Container>
                <Button onClick={() => {/* future select action */ }}>
                  <Text>{territory.name}</Text>
                </Button>
              </Container>
              <Container>
                <Button onClick={() => onEdit(territory)}>
                  <MdEdit size={20} />
                </Button>
                <Button
                  onClick={() => {
                    setTerritoryToDelete(territory);
                    setIsConfirmModalOpen(true);
                  }}
                >
                  <MdDelete size={20} color="#1976d2" /> 
                </Button>
              </Container>
            </Container>
          ))
        ) : (
          <Text>Empty</Text>
        )}
      </Container>



      {successMessage && <SuccessMessage>{successMessage}</SuccessMessage>}
      <Container className="action-section">
        <Container className="action-buttons">
          <Button variant="create" onClick={() => onEdit(null)}>
            <Text>Create New Territory</Text>
          </Button>
        </Container>
      </Container>
      <ConfirmDialog
        isOpen={isConfirmModalOpen}
        title={`Delete ${territoryToDelete?.name}?`}
        message="This action cannot be undone. Are you sure you want to delete this territory?"
        onConfirm={confirmDeleteTerritory}
        onCancel={() => {
          setIsConfirmModalOpen(false);
          setTerritoryToDelete(null);
        }}
        confirmText="Delete"
        cancelText="Cancel"
      />




    </StyledWorkbookFilterList>
  )
}



export default WorkbookTerritoryList

